import vuetify from '@/plugins/vuetify';
import Page from '@/plugins/page';

import Loader from '@/components/Loader.vue';
import MiButton from '@/components/MiButton/MiButton.vue';
import MiEditable from '@/components/MiEditable/MiEditable.vue';
import MiToggle from '@/components/MiToggle/MiToggle.vue';
import MiForm from '@/components/MiForm/MiForm.vue';
import MiDataTable from '@/components/MiDataTable/MiDataTable.vue';
import MiDataTableAction from '@/components/MiDataTable/MiDataTableAction/MiDataTableAction.vue';
import MiDataTableBulkAction from '@/components/MiDataTable/MiDataTableBulkAction/MiDataTableBulkAction.vue';
import MiDialog from '@/components/MiDialog/MiDialog.vue';
import MiElementPanel from '@/components/MiElementPanel/MiElementPanel.vue';
import MiElementPanelItem from '@/components/MiElementPanelItem/MiElementPanelItem.vue';

// TODO: remove
import MiElementPanelItemsWrap from '@/components/MiElementPanelItemsWrap/MiElementPanelItemsWrap.vue';
//
import MiElementPanelTabbed from '@/components/MiElementPanelTabbed/MiElementPanelTabbed.vue';
import MiFileUpload from '@/components/MiFileUpload/MiFileUpload.vue';
import MiListItem from '@/components/MiListItem/MiListItem.vue';
import MiMap from '@/components/MiMap/MiMap.vue';
import MiMenu from '@/components/MiMenu/MiMenu.vue';
import MiStepDialog from '@/components/MiStepDialog/MiStepDialog.vue';
import SideMenu from '@/components/SideMenu/SideMenu.vue';
import Title from '@/components/Title.vue';
import ActionIcon from '@/components/ActionIcon.vue';
import ElementPanel from '@/components/ElementPanel.vue';

import Vue from 'vue';
import DOMPurify from 'dompurify';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueMask from 'v-mask';
import router from './router';
import store from './store';
import '@/support/Filters';
import App from './App.vue';
import { Settings } from 'luxon';

Vue.config.productionTip = false;

Vue.use(VueMask);
Vue.use(Page);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAt5SNV4em69JN6IbxtfnFuz5wrexLLq_Q',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    /// / If you want to set the version, you can do so:
    // v: '3.26',
  },

  /// / If you intend to programmatically custom event listener code
  /// / (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  /// / instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  /// / you might need to turn this on.
  // autobindAllEvents: false,

  /// / If you want to manually install components, e.g.
  /// / import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  /// / Vue.component('GmapMarker', GmapMarker)
  /// / then set installComponents to 'false'.
  /// / If you want to automatically install all the components this property must be set to 'true':
  installComponents: true,
});

Vue.component('ElementPanel', MiElementPanel);
Vue.component('ElementPanelItem', MiElementPanelItem);
Vue.component('ElementPanelItemsWrap', MiElementPanelItemsWrap);
Vue.component('ElementPanelTabbed', MiElementPanelTabbed);
Vue.component('Loader', Loader);
Vue.component('MiBulkAction', MiDataTableBulkAction);
Vue.component('MiButton', MiButton);
Vue.component('MiDataTable', MiDataTable);
Vue.component('MiDataTableAction', MiDataTableAction);
Vue.component('MiDialog', MiDialog);
Vue.component('MiEditable', MiEditable);
Vue.component('MiToggle', MiToggle);
Vue.component('MiForm', MiForm);
Vue.component('MiFileUpload', MiFileUpload);
Vue.component('MiListItem', MiListItem);
Vue.component('MiMap', MiMap);
Vue.component('MiMenu', MiMenu);
Vue.component('MiStepDialog', MiStepDialog);
Vue.component('SideMenu', SideMenu);
Vue.component('Title', Title);
Vue.component('ActionIcon', ActionIcon);
Vue.component('ElementPanel', ElementPanel);

// DOMPurify hook for links
DOMPurify.addHook('afterSanitizeAttributes', (node: Node) => {
  if ('target' in node) {
    (node as HTMLElement).setAttribute('target', '_blank');
    // prevent https://www.owasp.org/index.php/Reverse_Tabnabbing
    (node as HTMLElement).setAttribute('rel', 'noopener noreferrer');
  }
});

Settings.defaultZoneName = 'utc';

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
